import moment from 'moment';
import { getData } from '@/components/report/service';
import { computeWeight } from '@/utils/query';
import { ModalsQuery } from '../Modals/Filter';
import { crudRequest } from '@/services/api';

export default {
  namespace: 'outletsdepartStorehouseSRModals',
  state: {
    modalsVisible: false,
    /**
     * @modalsType
     * 1: 一派留仓总票数
     * 2: 二派留仓总票数
    */
    modalsType: '',
    modalsTitle: '',
    modalsDesSite: '',
    modalsReceiveSite: '',
    modalsList: [],
    centerFilter: '',
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          modalsVisible: false,
          modalsList: []
        },
      });
    },
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/outletsdepartStorehouse/search_detail')   // 日志
      yield put({ type: 'getModalData' });
    },
    *getModalData(_, { call, put, select }) {
      let query = yield select(({ outletsdepartStorehouseSR }) => {
        const { endDate } = outletsdepartStorehouseSR.filter;
        return {
          startDate: endDate + ' 00:00:00',
          endDate: endDate + ' 23:59:59',
        }
      });
      const {
        modalsType, modalsDesSite, centerFilter, modalsReceiveSite
      } = yield select(({ outletsdepartStorehouseSRModals }) => outletsdepartStorehouseSRModals);
      const modalsfilter = ModalsQuery({
        centerFilter,
        destinationSite: modalsDesSite,
        receiveSite: modalsReceiveSite,
        startDate: query.startDate,
        endDate: query.endDate,
      })
      let filter;
      if (modalsType === 1) {
        filter = modalsfilter[0]
      } else if (modalsType === 2) {
        filter = modalsfilter[1]
      }

      const data = yield call(getData, filter);
      const newData = data || [];
      let ticket = 0;
      newData.forEach((item, index) => {
        item.index = index;
        item.goodsWeight = Number.parseInt(item.goodsWeight);
        ticket += item.ticket;
      });
      // console.log(111, newData)
      // console.log('总票数:', ticket)
      yield put({
        type: 'update',
        payload: {
          modalsList: newData
        },
      });
    }
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
